<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="copyright"><a id="page_4"></a>This is a work of fiction. All of the characters, organizations, and events portrayed in this novel are either products of the author’s imagination or are used fictitiously.</p>
<p class="copyright"><span class="small">MYSTERIUM</span></p>
<p class="copyright">Copyright © 1994 by Robert Charles Wilson</p>
<p class="copyright">Originally published by Bantam Books, a division of Bantam<br/>Doubleday Dell Publishing Group, Inc.</p>
<p class="copyright">All rights reserved.</p>
<p class="copyright">An Orb Book<br/>Published by Tom Doherty Associates, LLC<br/>175 Fifth Avenue<br/>New York, NY 10010</p>
<p class="copyright"><a href="http://www.tor-forge.com" target="_blank">www.tor-forge.com</a></p>
<p class="copyright">ISBN 978-0-7653-2741-3</p>
<p class="copyright">First Orb Edition: September 2010</p>
<p class="copyright">Printed in the United States of America</p>
<p class="copyright">0  9  8  7  6  5  4  3  2  1</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?7147556e